import { render, staticRenderFns } from "./ReferralForEvaluationRequest.vue?vue&type=template&id=b73e8530&scoped=true"
import script from "./ReferralForEvaluationRequest.vue?vue&type=script&lang=js"
export * from "./ReferralForEvaluationRequest.vue?vue&type=script&lang=js"
import style0 from "./ReferralForEvaluationRequest.vue?vue&type=style&index=0&id=b73e8530&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b73e8530",
  null
  
)

export default component.exports